// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/assign-category/app/css/app.css
// module id = 790
// module chunks = 0